module.exports = __webpack_public_path__ + "media/images/lb/483-f180295f6ee7656a39695493a3e19e21.svg";